import { type RefObject, useEffect } from 'react';

interface ScrollIntoViewParams {
  elementRef: RefObject<HTMLElement | null>;
  condition: boolean;
  block?: 'start' | 'center' | 'end' | 'nearest';
}

/**
 * Hook that conditionally scrolls an element into view
 * @param options Object containing elementRef, condition, and block
 */
export const useScrollIntoViewConditionally = ({
  elementRef,
  condition,
  block,
}: ScrollIntoViewParams): void => {
  useEffect(() => {
    if (condition && elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: 'smooth',
        block: block || 'center',
      });
    }
  }, [condition, elementRef, block]);
};
